import {
  acceptLead,
  rejectLead,
  declineFundingMatch,
  OPEN_DECLINE_FUNDING_MATCH_MODAL,
  CLOSE_DECLINE_FUNDING_MATCH_MODAL,
} from './types';

export * from './updateMatchStatusModal/actions';

export const requestDeclineFundingMatch = (
  activityId,
  declineReason,
  fundingSearchId,
  promise,
) => ({
  type: declineFundingMatch.request,
  activityId,
  declineReason,
  promise,
  fundingSearchId,
});
export const requestDeclineFundingMatchSuccess = (activityId, response) => ({
  type: declineFundingMatch.success,
  activityId,
  response,
});
export const requestDeclineFundingMatchFailure = (error) => ({
  type: declineFundingMatch.failure,
  error,
});
export const openDeclineFundingMatchModal = (activityInstance) => ({
  type: OPEN_DECLINE_FUNDING_MATCH_MODAL,
  activity: activityInstance,
});
export const closeDeclineFundingMatchModal = () => ({
  type: CLOSE_DECLINE_FUNDING_MATCH_MODAL,
});

export const requestAcceptLead = ({ fundingMatchId, fundingSearchId }) => ({
  fundingSearchId,
  fundingMatchId,
  type: acceptLead.request,
});

export const requestRejectLead = ({ fundingMatchId, fundingSearchId }, reason, comment) => ({
  type: rejectLead.request,
  fundingMatchId,
  fundingSearchId,
  reason,
  comment,
});
